<template>
  <component 
    :is="to ? 'a' : 'div'"
    v-bind="to ? { href: to } : {}"
    class="card h-100 shadow-sm btn-widget text-decoration-none" 
    :class="`border-left-${variant}`"
    @click="$emit('click')"
  >
   <div class="card-body">
      <div 
        class="text-uppercase font-weight-bold font-xs mb-1"
        :class="`text-${variant}`"
      >
        {{ title }}
      </div>
      <div v-if="subTitle" class="small text-muted mb-2">{{ subTitle }}</div>
      <div class="h3 mb-0 font-weight-bold text-gray-800">
        <div v-if="loading" class="spinner-border spinner-border-sm" role="status">
          <span class="sr-only">Cargando...</span>
        </div>
        <span v-else>{{ value }}</span>
      </div>
    </div>
  </component>
</template>

<script>
export default {
    name: 'Widget',
    props: {
        title: {
            type: String,
            required: true
        },
        value: {
            type: [Number, String],
            required: true
        },
        variant: {
            type: String,
            default: 'primary'
        },
        subTitle: {
            type: String,
            default: ''
        },
        to: {
            type: [String, Object],
            default: null
        },
        loading: {
          type: Boolean,
          default: false
        }
    }
}
</script>

<style scoped>
.btn-widget {
  cursor: pointer;
  transition: transform 0.2s, box-shadow 0.2s;
}

.btn-widget:hover {
  transform: translateY(-5px);
  box-shadow: 0 0.5rem 1rem rgba(0, 0, 0, 0.15) !important;
}

.font-xs {
  font-size: 0.7rem;
  letter-spacing: 0.05em;
}

.border-left-primary {
  border-left: 0.25rem solid #4e73df !important;
}

.border-left-success {
  border-left: 0.25rem solid #1cc88a !important;
}

.border-left-info {
  border-left: 0.25rem solid #36b9cc !important;
}

.border-left-warning {
  border-left: 0.25rem solid #f6c23e !important;
}

.border-left-danger {
  border-left: 0.25rem solid #e74a3b !important;
}

.border-left-secondary {
  border-left: 0.25rem solid #858796 !important;
}

.border-left-muted {
  border-left: 0.25rem solid #b7b9cc !important;
}

.text-gray-800 {
  color: #5a5c69 !important;
}

.shadow-sm {
  box-shadow: 0 0.125rem 0.25rem 0 rgba(58, 59, 69, 0.2) !important;
}
</style>